var drawing = require('./visuals/drawing');

// AUDIO
var context = require('./tools/context');
var _temporaryBuffer = context.createBufferSource();
delete _temporaryBuffer;

// click
var tool = new paper.Tool();
tool.minDistance = 7;

var paused = true;

tool.onMouseDown = function onMouseDown(event) {
	if (paused) return;
	drawing.start(event);
}

tool.onMouseDrag = function onMouseDrag(event) {
	if (paused) return;
	drawing.drag(event);
}

tool.onMouseUp = function onMouseUp(event) {
	if (paused) return;
	drawing.end(event);
}

module.exports = {
	type: 'create',
	start: function() {
		paused = false;
	},
	pause: function() {
		paused = true;
	},
	play: function() {
		paused = false;
	},
	finished: function(){
		paused = true;
		drawing.stop();
	}
}